import React from 'react';
import AirlineDetailPage from '../components/AirlineDetailPage';
import { JETBLUE_AIRWAYS } from '../data/airlinesData';

export default function JetBluePage() {
  return <AirlineDetailPage airline={JETBLUE_AIRWAYS} />;
}
